module.exports = "/_next/static/chunks/fonts/kit-presentation-mask-429ee71b07e93068c5f7f0c159c52b97.svg";